import script from "./AttendanceQr.client.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendanceQr.client.vue?vue&type=script&setup=true&lang=ts"

import "./AttendanceQr.client.vue?vue&type=style&index=0&id=387dca12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387dca12"]])

export default __exports__